import { useQuery } from "@tanstack/react-query"
import { vaultQuery } from "../lib/vaultQuery"

export function useVaultEntriesQuery() {
  return useQuery(vaultQuery())
}
